/**
 * Wise Line Tools - Attach & Save Storefront Cart & Checkout Handler
 */
(function () {
  'use strict';

  let isUpdating = false;

  async function getCart() {
    try {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      const res = await fetch(rootUrl + 'cart.js');
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function findItemRow(item, index) {
    // 1. Try explicit key or index selectors
    if (item.key) {
      const elKey = document.querySelector(`[data-cart-item-key="${item.key}"]`);
      if (elKey) return elKey;
    }
    const elIdx = document.querySelector(`.cart-item[data-index="${index + 1}"], [data-cart-item-index="${index + 1}"]`);
    if (elIdx) return elIdx;

    // 2. Search container rows containing the variant ID or product handle
    const variantIdStr = String(item.variant_id);
    const itemHandle = item.handle;
    const candidates = document.querySelectorAll('tr.cart-item, .cart-item, .cart-drawer__item, .cart__row, .cart-item-row');
    
    for (const cand of candidates) {
      const html = cand.innerHTML || '';
      if (html.includes(variantIdStr) || (itemHandle && html.includes(itemHandle))) {
        return cand;
      }
    }
    return null;
  }

  async function syncAttachSaveCart() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;

      let totalDiscountCents = 0;
      let hasAttachSaveItems = false;

      cart.items.forEach((item, index) => {
        if (item.properties && item.properties._custom_price && item.properties._original_price) {
          hasAttachSaveItems = true;
          const customPriceVal = parseFloat(item.properties._custom_price);
          const origPriceVal = parseFloat(item.properties._original_price);
          const diffPerItemCents = Math.round((origPriceVal - customPriceVal) * 100);
          totalDiscountCents += (diffPerItemCents * item.quantity);

          const formattedCustomPrice = '$' + customPriceVal.toFixed(2) + ' CAD';
          const formattedOrigPrice = '$' + origPriceVal.toFixed(2) + ' CAD';

          const row = findItemRow(item, index);
          if (row) {
            const priceContainers = row.querySelectorAll('.cart-item__price, .price, .cart-item__totals, .totals__subtotal-value, .price-item');
            priceContainers.forEach(container => {
              if (container && container.dataset.attachSaveUpdated !== item.key) {
                container.dataset.attachSaveUpdated = item.key;
                container.innerHTML = `<span style="color: #dc2626; font-weight: 700; font-size: 1.05em;">${formattedCustomPrice}</span> <s style="color: #9ca3af; font-size: 0.85em; margin-left: 6px;">${formattedOrigPrice}</s>`;
              }
            });
          }
        }
      });

      if (totalDiscountCents > 0) {
        const newSubtotalCents = cart.total_price - totalDiscountCents;
        const formattedNewSubtotal = '$' + (newSubtotalCents / 100).toFixed(2) + ' CAD';

        const subtotalSelectors = [
          '.totals__subtotal-value', 
          '.cart__subtotal', 
          '[data-cart-subtotal]',
          '.cart__totals-subtotal-value',
          '.cart-drawer__totals .totals__subtotal-value'
        ];
        subtotalSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => {
            el.innerText = formattedNewSubtotal;
          });
        });
      }

      if (hasAttachSaveItems) {
        bindCheckoutIntercept(cart);
      }
    } catch (e) {
      console.error('AttachSave Cart Handler Error:', e);
    } finally {
      setTimeout(() => { isUpdating = false; }, 200);
    }
  }

  function bindCheckoutIntercept(cart) {
    const handleCheckoutClick = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      showOverlay('Applying Attach & Save Discounts to Checkout...');

      try {
        const payload = {
          cart_items: cart.items.map(item => ({
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {}
          }))
        };

        const res = await fetch('/apps/quote-checkout/merge', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (res.ok) {
          const data = await res.json();
          if (data.checkout_url) {
            window.location.href = data.checkout_url;
            return;
          }
        }
      } catch (err) {
        console.error('AttachSave Checkout Redirect Error:', err);
      }

      // Fallback: Proceed to normal checkout if proxy fails
      window.location.href = '/checkout';
    };

    const checkoutButtons = document.querySelectorAll('form[action="/cart"] [name="checkout"], a[href="/checkout"], a[href="/cart/checkout"], button.checkout-btn, .ajaxcart__checkout, [name="checkout"]');
    checkoutButtons.forEach(btn => {
      if (!btn.dataset.attachSaveIntercepted) {
        btn.dataset.attachSaveIntercepted = "true";
        btn.addEventListener('click', handleCheckoutClick, true);
      }
    });

    const cartForms = document.querySelectorAll('form[action="/cart"]');
    cartForms.forEach(form => {
      if (!form.dataset.attachSaveIntercepted) {
        form.dataset.attachSaveIntercepted = "true";
        form.addEventListener('submit', handleCheckoutClick, true);
      }
    });
  }

  function showOverlay(msg) {
    if (document.getElementById('attach-save-loading-overlay')) return;
    const html = `
      <div id="attach-save-loading-overlay" style="
        position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
        background: rgba(17, 24, 39, 0.75); backdrop-filter: blur(8px);
        display: flex; flex-direction: column; justify-content: center; align-items: center;
        z-index: 99999999; color: #fff; font-family: sans-serif; opacity: 1; transition: opacity 0.2s ease;
      ">
        <div style="
          border: 4px solid rgba(255,255,255,0.2); border-top: 4px solid #dc2626;
          border-radius: 50%; width: 48px; height: 48px;
          animation: attach-save-spin 0.8s linear infinite; margin-bottom: 20px;
        "></div>
        <p style="font-size: 16px; font-weight: 600; color: #f3f4f6;">${msg}</p>
      </div>
      <style>@keyframes attach-save-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>
    `;
    document.body.insertAdjacentHTML('beforeend', html);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAttachSaveCart);
  } else {
    syncAttachSaveCart();
  }

  const observer = new MutationObserver((mutations) => {
    let shouldSync = false;
    for (const m of mutations) {
      if (m.type === 'childList' || m.type === 'attributes') {
        shouldSync = true;
        break;
      }
    }
    if (shouldSync) {
      syncAttachSaveCart();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'style']
  });
})();
